import { SITE_CONFIG_API_URL } from '@global/App/constants/constants';
import { SiteId } from 'wly-ecommerce-common';
import { logError } from '@src/global/utils/log';

export type DefaultSiteConfiguration = {
  siteKey: string;
  headerUrl: string;
  pricingDeterminationModel?: string;
  source?: string;
};

export type SpectrabaseSiteConfiguration = {
  headerUrl: string;
  footerUrl: string;
  headerFooterCSS: string;
  source: string; // Spectrabase always has a source
  pricingDeterminationModel?: string;
};

// Final union type
export type SiteConfiguration =
  | DefaultSiteConfiguration
  | SpectrabaseSiteConfiguration;

export type SiteConfigResponse = Record<SiteId, SiteConfiguration>;

const localToDevHostnameMap: Record<string, string> = {
  'local.checkout.wiley.com': 'dev.store.wiley.com',
  'local.graphicstandards.com': 'dev.graphicstandards.com',
  'local.vetdev.wiley.com': 'vetdev.wiley.com',
  'local.spectrabase.com': 'dev.spectrabase.com',
};

export const getSiteConfig = async (
  hostUrl?: string
): Promise<SiteConfigResponse> => {
  let hostname = hostUrl ? hostUrl.split('//')[1] : window.location.hostname;

  // Replace local hostnames with their dev values as the SiteConfig API does not support local hostnames
  if (Object.keys(localToDevHostnameMap).includes(hostname)) {
    hostname = localToDevHostnameMap[hostname];
  }

  const encodedDomain = btoa(hostname);
  const apiUrl = `${SITE_CONFIG_API_URL}?domain=${encodedDomain}`;

  try {
    const response = await fetch(apiUrl);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const config = await response.json();

    if (!config) {
      throw new Error(`Site config not returned from API.`);
    }

    return config;
  } catch (error) {
    logError(`Failed to fetch site config for ${hostname}:`, error);
    return null;
  }
};
